module.exports = __webpack_public_path__ + "static/img/v30_09.9a76779.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/v30_09.jpg
// module id = 5/yK
// module chunks = 3